import { BADGE_VARIANTS } from 'components/Badge'
import { PURCHASE_STATUS } from 'constants/common'
import { type StatusBadgeMapper } from './types'

export const ADMIN_PURCHASE_STATUS_BADGE_VALUES: StatusBadgeMapper = {
  [PURCHASE_STATUS.DRAFT]: {
    variant: BADGE_VARIANTS.GRAY,
  },
  [PURCHASE_STATUS.PENDING]: {
    variant: BADGE_VARIANTS.BLUE,
  },
  [PURCHASE_STATUS.PAID]: {
    variant: BADGE_VARIANTS.GREEN,
  },
  [PURCHASE_STATUS.PROCESSING]: {
    variant: BADGE_VARIANTS.ORANGE,
  },
  [PURCHASE_STATUS.SHIPPED]: {
    variant: BADGE_VARIANTS.ORANGE,
  },
  [PURCHASE_STATUS.DELIVERED]: {
    variant: BADGE_VARIANTS.GREEN,
  },
  [PURCHASE_STATUS.REFUNDED]: {
    variant: BADGE_VARIANTS.RED,
  },
  [PURCHASE_STATUS.VOID]: {
    variant: BADGE_VARIANTS.RED,
  },
} as const

export const CLIENT_PURCHASE_STATUS_BADGE_VALUES = {
  [PURCHASE_STATUS.DRAFT]: {
    variant: BADGE_VARIANTS.GRAY,
    text: 'Draft',
  },
  [PURCHASE_STATUS.PENDING]: {
    variant: BADGE_VARIANTS.RED,
    text: 'Waiting for payment',
  },
  [PURCHASE_STATUS.PAID]: {
    variant: BADGE_VARIANTS.ORANGE,
    text: 'Pending delivery',
  },
  [PURCHASE_STATUS.PROCESSING]: {
    variant: BADGE_VARIANTS.ORANGE,
    text: 'Processing',
  },
  [PURCHASE_STATUS.IN_PRODUCTION]: {
    variant: BADGE_VARIANTS.ORANGE,
    text: 'In production',
  },
  [PURCHASE_STATUS.SHIPPED]: {
    variant: BADGE_VARIANTS.ORANGE,
    text: 'Pending delivery',
  },
  [PURCHASE_STATUS.DELIVERED]: {
    variant: BADGE_VARIANTS.GREEN,
    text: 'Delivered',
  },
  [PURCHASE_STATUS.REFUNDED]: {
    variant: BADGE_VARIANTS.GRAY,
    text: 'Refunded',
  },
  [PURCHASE_STATUS.VOID]: {
    variant: BADGE_VARIANTS.GRAY,
    text: 'Void',
  },
}
